import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Input from '@material-ui/core/Input';
import numeral from 'numeral';
import List from '@material-ui/core/List';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import ListSubheader from '@material-ui/core/ListSubheader';
import InboxIcon from '@material-ui/icons/Add';
import InsulationWarningComponent from './InsulationWarningComponent';
import { adobeSelectInsulationProduct } from '../../utils/analytics';

class InsulationLayer extends Component {

  state = {
    anchorEl: undefined,
    productOpen: false,
    thicknessOpen: false,
    popover: false,
    popoverAnchorEl: undefined,
    warnings: [],
    preview: false,
    previewImg: null,
    previewStyle: null,
  };

  handleProductMenuClick = event => {
    this.setState({ productOpen: true, anchorEl: event.currentTarget });
  };

  handleThicknessMenuClick = event => {
    this.setState({ thicknessOpen: true, anchorEl: event.currentTarget });
  };

  handleProdcutMenuRequestClose = (item, index, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.setState({ productOpen: false});
    if(item === -3) {
      this.props.openSetting();
      return;
    }
    if (this.props.onChange && item) {
      // Let's check is the current selected thickness available with new product
      let newProduct = null;
      for(let i = 0; i < this.props.products.length; i++) {
        if(this.props.products[i].Nid === item) {
          newProduct = this.props.products[i];
        }
      }
      adobeSelectInsulationProduct(newProduct.name);
      let isThicknessInProduct = false;
      let newSelectedThickness = '0';
      const standardThicknesses = newProduct['Standard-thickness'].split(',');
      for(let i = 0; i < standardThicknesses.length; i++) {
        if( Number(standardThicknesses[i]) ===  Number(this.props.selectedThickness) ) {
          isThicknessInProduct = true;
          break;
        }
        if( Number(newSelectedThickness) < Number(this.props.selectedThickness) ) {
          newSelectedThickness = standardThicknesses[i];
        }
      }

      if(!isThicknessInProduct) {
        this.props.onChange({selectedItem: item, selectedThickness: newSelectedThickness, index: index});
      } else {
        this.props.onChange({selectedItem: item, index: index});
      }
    }
  };

  handleThicknessMenuRequestClose = (item, index, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.setState({ thicknessOpen: false});
    if (this.props.onChange && item) {
      this.props.onChange({selectedThickness: item, index: index});
    }
  };

  removeInsulationLayer = (id, index) => {
    this.setState({ thicknessOpen: false, productOpen: false});
    if (this.props.onDelete) {
      this.props.onDelete({id: id, index: index});
    }
  };

  thicknessInputChange = (index, e) => {
    if (this.props.onChange) {
      this.props.onChange({selectedThickness: e.target.value, index: index});
    }
  };

  thumbnailOnClickHandler = (img, e) => {
    const rect = e.target.getBoundingClientRect();
    this.setState({preview: true, previewImg: img, previewStyle: {left: rect.x + 'px', top: rect.y + 'px'}});

    e.preventDefault();
    e.stopPropagation();
  };

  render() {
    const {products, resultLayer, selectedItem, selectedThickness, index, disabled, lastLayer, firstLayer, cladding, claddingWarning, objectWarnings, customHeader} = this.props;


    let selectedProduct = {};
    const menuItems = (<List>{products.filter( item => {
      if(item.custom) {
        return false;
      }
      return true;
    }).map((option, key) => {
      let selected = false;
      if(selectedItem && Number(option.Nid) === Number(selectedItem)) {
        selectedProduct = option;
        selected = true;
      }

      let img;
      if(option.hasOwnProperty('Photo-of-the-product') && option['Photo-of-the-product'] !== '') {
        img = option['Photo-of-the-product'];
      }

      return (<MenuItem classes={{root: 'layer-dropdown-item'}} key={key} style={{display: 'block'}} selected={selected} onClick={this.handleProdcutMenuRequestClose.bind(this, option.Nid, index)}>
        {img ? <i className="fa fa-picture-o ico" aria-hidden="true" onClick={this.thumbnailOnClickHandler.bind(this, img)} ></i> : null}
        <span className="text">{option.name}</span>
      </MenuItem>);
    })}</List>);

    let customItems = products.filter( item => {
      if(item.custom) {
        return true;
      }
      return false;
    });

    let divider;
    if(customItems && customItems.length) {
      customItems = (<List subheader={<ListSubheader>{customHeader}</ListSubheader>}>{customItems.map(option => {
        if(selectedItem !== undefined && option.id === selectedItem) {
          selectedProduct = option;
        }
        return (<MenuItem button key={option.id} selected={selectedItem ? option.id === selectedItem : false} onClick={this.handleProdcutMenuRequestClose.bind(this, option.id, index)}>
          {option.id === -3 ? <ListItemIcon>
            <InboxIcon style={{marginRight: -10 + 'px', color: '#d20000'}} />
          </ListItemIcon> : null}
          {option.id === -3 ? <ListItemText classes={{root: 'dropdownlist-create-new-custom-item'}} primary={option.name} />
          : <ListItemText primary={option.name} /> }
        </MenuItem>);
      })}</List>);
      divider = <Divider />;
    }

    // Thickness dropdownlist
    //
    let thicknessList;
    if(selectedProduct && selectedProduct.hasOwnProperty('Standard-thickness')) {
      thicknessList = selectedProduct['Standard-thickness'].split(',').map( (option, key) => {
        let selected = false;
        if(selectedThickness && Number(option) === Number(selectedThickness)) {
          selected = true;
        }
        return (<MenuItem key={key} style={{display: 'block'}} selected={selected} onClick={this.handleThicknessMenuRequestClose.bind(this, option, index)}>
          {option}
        </MenuItem>);
      });
    }

    const temp = (resultLayer && resultLayer.surfaceTemperature) ? resultLayer.surfaceTemperature : null;
    const warnings = (resultLayer && resultLayer.warnings) ? resultLayer.warnings : null;
    const objectWarningsItems = (firstLayer && objectWarnings) ? objectWarnings : null;
    const insulationCladdingWarnings = (claddingWarning && index === 0) ? claddingWarning : null;

    return (
      <div className={'layer ' + (cladding ? 'cladding' : '')} >
        <div className="layer-container">
        {lastLayer ? null : <i className="fa fa-minus-circle remove-icon" aria-hidden="true" onClick={this.removeInsulationLayer.bind(this, selectedProduct.Nid, index)} />}
        <div className="product-dropdownlist" onClick={this.handleProductMenuClick} aria-owns={this.state.productOpen ? 'product-menu' : null} aria-haspopup="true">
          <label>{selectedProduct.name}</label>
          <i className="fa fa-chevron-down" />
          <Menu
            id="product-menu"
            anchorEl={this.state.anchorEl}
            open={this.state.productOpen}
            variant="menu"
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            onClose={this.handleProdcutMenuRequestClose.bind(this, null, null)}
            MenuListProps={{
              style: {
                width: 400,
                maxHeight: 400
              },
            }}
          >
            {menuItems}
            {(customItems && customItems.props && customItems.props.children && customItems.props.children.length) ? divider : null}
            {(customItems && customItems.props && customItems.props.children && customItems.props.children.length) ? customItems : null}
          </Menu>
        </div>

        <div className="thickness-dropdownlist" aria-owns={this.state.thicknessOpen ? 'thickness-menu' : null} aria-haspopup="true">
          <div className="input-container" >
            <Input className="input" value={selectedThickness} onChange={this.thicknessInputChange.bind(this, index)} />
          </div>
          <Menu
            id="thickness-menu"
            anchorEl={this.state.anchorEl}
            open={this.state.thicknessOpen}
            variant="menu"
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            onClose={this.handleThicknessMenuRequestClose.bind(this, null, null)}
            MenuListProps={{
              style: {
                width: 100,
                maxHeight: 400
              },
            }}
          >
            {thicknessList}
          </Menu>
          <i className="fa fa-chevron-down" onClick={this.handleThicknessMenuClick}/>
          <div className="unit">mm</div>
        </div>

        { !disabled ?
           <div className="temperature-holder">
            <div className="temperature">
              <label>{numeral(temp).format('0.0')} °C</label>
            </div>
            <div className="left-arrow" />
            <div className="right-arrow" />
          </div>
          : null}
        { (insulationCladdingWarnings && insulationCladdingWarnings.length > 0) ? <InsulationWarningComponent cladding warnings={insulationCladdingWarnings} /> : null }
        { (warnings && warnings.length > 0) ? <InsulationWarningComponent warnings={warnings} /> : null }
        { (objectWarningsItems && !disabled) ? <InsulationWarningComponent object warnings={objectWarningsItems} /> : null }

        </div>
        {disabled ? <div className="disabled"/> : null}
        {this.state.preview ? <div className="img-preview" onClick={()=>{this.setState({preview: false, previewImg: null});}}><img src={this.state.previewImg} style={this.state.previewStyle} /></div> : null}
      </div>
    );
  }
}

InsulationLayer.propTypes = {

  openSetting: PropTypes.any,
  onChange: PropTypes.any,
  products: PropTypes.any,
  selectedThickness: PropTypes.any,
  onDelete: PropTypes.any,
  resultLayer: PropTypes.any,
  selectedItem: PropTypes.any,
  index: PropTypes.any,
  disabled: PropTypes.any,
  lastLayer: PropTypes.any,
  firstLayer: PropTypes.any,
  cladding: PropTypes.any,
  claddingWarning: PropTypes.any,
  objectWarnings: PropTypes.any,
  customHeader: PropTypes.any,
};

export default InsulationLayer;
